module.exports = __webpack_public_path__ + "static/img/gm_benefit02.e23d6451.png";